import React from "react";
import "./ImageTextLayout.scss";

const ImageTextLayout = ({ 
  image, 
  imageAlt, 
  titleIcon, 
  title, 
  children, 
  className = "", 
  imageClassName = "",
  contentClassName = "" 
}) => {
  return (
    <main className={`image-text-layout ${className}`}>
      <section className={`image-text-layout__image-section ${imageClassName}`}>
        <img src={image} alt={imageAlt} className="image-text-layout__main-image" />
      </section>
      <section className={`image-text-layout__content-section ${contentClassName}`}>
        <div className="image-text-layout__title-container">
          {titleIcon && (
            <img src={titleIcon} alt="Title icon" className="image-text-layout__title-icon"/>
          )}
          <h2 className="image-text-layout__section-title">{title}</h2>
        </div>
        <div className="image-text-layout__text-content">
          {children}
        </div>
      </section>
    </main>
  );
};

export default ImageTextLayout;